import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiBookmark,
  FiCheckCircle,
  FiClock,
  FiCopy,
  FiEdit3,
  FiMail,
  FiPlus,
  FiSend
}=FiIcons;

const activityIcons={
  created: FiPlus,
  edited: FiEdit3,
  template: FiBookmark,
  copied: FiCopy,
  reminder: FiMail,
  update: FiSend,
  notes: FiCheckCircle
};

function formatActivityDate(value) {
  const date=new Date(value);

  if (Number.isNaN(date.getTime())) {
    return 'Recently';
  }

  const month=String(date.getMonth()+1).padStart(2,'0');
  const day=String(date.getDate()).padStart(2,'0');
  const year=String(date.getFullYear()).slice(-2);
  return `${month}-${day}-${year} · ${date.toLocaleTimeString([],{
    hour: 'numeric',
    minute: '2-digit'
  })}`;
}

function EventActivityTimeline({activities}) {
  return (
    <section className="panel event-activity">
      <div className="summary-title">
        <div>
          <span className="number">05</span>
          <div>
            <h2>Activity timeline</h2>
            <p>Recent updates and actions for this event.</p>
          </div>
        </div>
      </div>

      {activities.length===0 ? (
        <p className="activity-empty">No activity has been recorded yet.</p>
      ) : (
        <div className="activity-list">
          {activities.map((activity)=> {
            const icon=activityIcons[activity.type] || FiClock;

            return (
              <div className="activity-item" key={activity.id}>
                <span className="activity-icon">
                  <SafeIcon icon={icon} />
                </span>
                <div className="activity-content">
                  <strong>{activity.title}</strong>
                  <p>{activity.description}</p>
                  <time dateTime={activity.createdAt}>
                    {formatActivityDate(activity.createdAt)}
                  </time>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default EventActivityTimeline;